export const INCOME_RANGES = [
  "<$25,000",
  "$25,001-$50,000",
  "$50,001-$75,000",
  "$75,001-$100,000",
  ">$100,000",
];
